__webpack_require__.p = "https://bmidxbitalyplprod.netlify.app/";